import { convertToISOSTring } from '@/utils/commons'
import { useState } from 'react'

const getType = type => {
  if (!type) return type
  return type.toLowerCase() === 'text' ? 'string' : type
}

export const useDataTable = () => {
  const [sortingObj, setSortingObj] = useState({})
  const [searchArr, createSearchArray] = useState([])
  const [pageIndex, setPageIndex] = useState(0)

  const handleDateType = (searchObj) => {
    if (!searchObj.value) {
      searchObj.value = '';
      return;
    }

    const date = new Date(searchObj.value);
    searchObj.value = isNaN(date.getTime())
      ? '' // Invalid date
      : new Intl.DateTimeFormat('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          timeZone: 'UTC',
        }).format(date);
  };

  const setSearchArry = (() => {
    let debounceTimer

    return searchObj => {
      // Convert type if it's a text field
      if (searchObj.type) {
        searchObj.type = getType(searchObj.type)
      }

      if (searchObj.type === 'date') {
        handleDateType(searchObj)
      }

      if (searchObj.type === 'dateRange') {
        const { from, to } = searchObj.value

        const formatDate = (dateString, isStartDate, isEndDate) => {
          if (!dateString) return ''
          const utcDate = new Date( dateString.split('T')[0])

          const date = new Date(Date.UTC(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate()))
          
          if (isNaN(date.getTime())) return '' // Invalid date
          return convertToISOSTring(date, isStartDate, isEndDate)
        }

        const formattedFromDate = formatDate(from, true, false)
        const formattedToDate = formatDate(to, false, true)

        // Set value to empty if both dates are empty or invalid
        if (!formattedFromDate && !formattedToDate) {
          searchObj.value = ''
        } else {
          searchObj.value = `${formattedFromDate},${formattedToDate}`
        }
      }

      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(() => {
        const isEmptyValue = (value) => {
          if (!value || value === '') return true
          if (searchObj.type === 'dateRange' && (value === ',' || value === ',,' || value.split(',').every(d => !d))) return true
          return false
        }

        // Remove items with empty values and handle new search
        if (isEmptyValue(searchObj.value)) {
          // Remove the item with the matching field
          const filteredArray = searchArr.filter(filter => filter.field !== searchObj.field)
          createSearchArray(filteredArray)
        } else {
          // Update existing or add new item
          const index = searchArr.findIndex(filter => filter.field === searchObj.field)
          if (index !== -1) {
            // Update existing item
            const updatedArray = [...searchArr]
            updatedArray[index] = searchObj
            createSearchArray(updatedArray)
          } else {
            // Add new item
            createSearchArray([...searchArr, searchObj])
          }
        }
      }, 1000)
    }
  })()

  const resetSearchArr = () => {
    createSearchArray([])
  }


  const handleResetAll = () => {
    createSearchArray([])
    setSortingObj({})
    setPageIndex(0)
  }

  return {
    searchArr,
    sortingObj,
    pageIndex,
    setSortingObj,
    setSearchArry,
    setPageIndex,
    resetSearchArr,
    handleResetAll
  }
}

